import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'
import { useI18n } from '@rushplay/i18n'

import { Button } from '../button'
import { CasinoGameTile } from '../casino-game-tile'
import { GameQuery } from '../game-query'
import { GameTileAnimation } from '../game-tile-animation'
import { GameTileSection } from '../game-tile-section'
import { Parallax } from '../parallax'
import { useDebouncedState } from '../use-debounce-state'

export function SearchResults(props) {
  const [value, setValue, setValueImmediate] = useDebouncedState(
    600,
    props.searchQuery.text
  )
  const history = ReactRouter.useHistory()
  const i18n = useI18n()
  const hasValue = Boolean(Object.keys(props.searchQuery).length)
  const isLiveCasino = history?.location?.pathname?.includes('live-casino')

  const params = React.useMemo(
    () => ({
      ...props.searchQuery,
      limit: 24,
      live_casino: isLiveCasino,
    }),
    [value, props.searchQuery.providers, props.searchQuery.sub_providers]
  )

  React.useEffect(() => {
    if (!props.searchQuery.text) {
      setValueImmediate(null)
    } else {
      setValue(props.searchQuery.text)
    }
  }, [props.searchQuery.text])

  return (
    <GameQuery name="search" params={params}>
      {gq => (
        <React.Fragment>
          <Common.Box
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Common.Space pb={[1, 2]} pt={[1, 2]}>
              <Common.Text fontFamily="head" textAlign="center" as="h1">
                {hasValue
                  ? gq.ids.length > 0
                    ? i18n.translate('search-results.match', {
                        amount: gq.isLoading ? '...' : gq.ids.length,
                        total: gq.isLoading ? '...' : gq.totalCount,
                      })
                    : i18n.translate('search-results.no-match')
                  : i18n.translate('search-results.incitament')}
              </Common.Text>
            </Common.Space>
            {hasValue && (
              <Common.Box ml={0}>
                <Button onClick={props.onReset}>
                  {i18n.translate('search-results.reset')}
                </Button>
              </Common.Box>
            )}
          </Common.Box>
          {hasValue && gq.games.length > 0 && (
            <div>
              <GameTileSection
                size="medium"
                layout="grid"
                colorMode="dark"
                columns={gq?.games?.length}
                containWidth
              >
                {() =>
                  gq?.games?.map((game, index) => (
                    <GameTileAnimation
                      key={game.id}
                      delay={(index % 24) * 0.04}
                    >
                      <ReactRouter.Link
                        to={`/casino/games/${game.id}?referrer=casino`}
                      >
                        <Parallax>
                          <CasinoGameTile id={game.id} size="medium" />
                        </Parallax>
                      </ReactRouter.Link>
                    </GameTileAnimation>
                  ))
                }
              </GameTileSection>

              {gq.onLoadMore && (
                <Common.Box display="flex" justifyContent="center" pt={3}>
                  <Button onClick={gq.onLoadMore}>
                    {i18n.translate('search-results.show-more')}
                  </Button>
                </Common.Box>
              )}
            </div>
          )}
        </React.Fragment>
      )}
    </GameQuery>
  )
}

SearchResults.propTypes = {
  searchQuery: PropTypes.object,
  onReset: PropTypes.func.isRequired,
}

// For @loadable/components
export default SearchResults
